import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/Home/HomeView.vue";
import { USER_TOKEN } from "@/config/catch";
import { useLocalStorage } from "@/utils/storage";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login/index.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/Product/index.vue"),
    children: [
      {
        path: "/catalogue/:category",
        name: "product-catalogue",
        component: () => import("../views/Product/Catalogue.vue"),
        meta: {
          title: "产品目录",
        },
      },
      {
        path: "/catalogue/search/:keyword",
        name: "product-catalogue-search",
        component: () => import("../views/Product/Search.vue"),
        meta: {
          title: "搜索结果",
        },
      },
      {
        path: "/product/detail/:id",
        name: "product-detail",
        component: () => import("../views/Product/Detail.vue"),
        meta: {
          title: "产品详情",
        },
      },
      {
        path: "/product/detailSearch/:id",
        name: "product-detail-search",
        component: () => import("../views/Product/DetailSearch.vue"),
        meta: {
          title: "产品详情",
        },
      },
    ],
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("../views/Personal/index.vue"),
    meta: {
      title: "个人中心",
      requiresAuth: true,
    },
    children: [
      {
        path: "/order/all",
        name: "order-all",
        component: () => import("../views/Personal/order/index.vue"),
        meta: {
          title: "全部订单",
          orderStatus: "all",
          requiresAuth: true,
        },
      },
      {
        path: "/order/consumption",
        name: "order-consumption",
        component: () => import("../views/Personal/order/consumption.vue"),
        meta: {
          title: "消费记录",
          orderStatus: "consumption",
          requiresAuth: true,
        },
      },
      {
        path: "/order/pending",
        name: "order-pending",
        component: () => import("../views/Personal/order/index.vue"),
        meta: {
          title: "待支付订单",
          orderStatus: "pending",
          requiresAuth: true,
        },
      },
      {
        path: "/order/processing",
        name: "order-processing",
        component: () => import("../views/Personal/order/index.vue"),
        meta: {
          title: "待发货订单",
          orderStatus: "processing",
          requiresAuth: true,
        },
      },
      {
        path: "/order/shipped",
        name: "order-shipped",
        component: () => import("../views/Personal/order/index.vue"),
        meta: {
          title: "待收货订单",
          orderStatus: "shipped",
          requiresAuth: true,
        },
      },
      {
        path: "/order/completed",
        name: "orderCompleted",
        component: () => import("../views/Personal/order/index.vue"),
        meta: {
          title: "已完成订单",
          orderStatus: "completed",
          requiresAuth: true,
        },
      },
      {
        path: "/integral",
        name: "personal-integral",
        component: () => import("../views/Personal/integral/index.vue"),
        meta: {
          title: "我的积分",
          requiresAuth: true,
        },
      },
      {
        path: "/account",
        name: "personal-account",
        component: () => import("../views/Personal/account/index.vue"),
        meta: {
          title: "我的账户",
          requiresAuth: true,
        },
      },
      {
        path: "/userInfo",
        name: "personal-userInfo",
        component: () => import("../views/Personal/account/userInfo.vue"),
        meta: {
          title: "个人信息",
          requiresAuth: true,
        },
      },
      {
        path: "/invoice",
        name: "personal-invoice",
        component: () => import("../views/Personal/invoice.vue"),
        meta: {
          title: "开票信息",
          requiresAuth: true,
        },
      },
      {
        path: "/focus",
        name: "personal-focus",
        component: () => import("../views/Personal/focus/index.vue"),
        meta: {
          title: "关注中心",
          requiresAuth: true,
        },
      },
      {
        path: "/address/list",
        name: "personal-address-list",
        component: () => import("../views/Personal/address/index.vue"),
        meta: {
          title: "收获地址",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/integral-mall",
    name: "mall",
    component: () => import("../views/Mall/index.vue"),
    children: [
      {
        path: "/integral-mall",
        name: "integral-mall",
        component: () => import("../views/Mall/Integral.vue"),
        meta: {
          title: "积分商城",
          requiresAuth: false,
        },
      },
      {
        path: "/integral-mall/checkout/:no",
        name: "integral-checkout",
        component: () => import("../views/Mall/checkout/index.vue"),
        meta: {
          title: "结算页",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/brands",
    name: "brands",
    component: () => import("../views/Brand/index.vue"),
    meta: {
      title: "合作品牌",
      requiresAuth: false,
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About/index.vue"),
    meta: {
      title: "关于我们",
      requiresAuth: false,
    },
  },
  {
    path: "/ximi",
    name: "ximi",
    component: () => import("../views/Ximi/index.vue"),
    meta: {
      title: "走进金试",
      requiresAuth: false,
    },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../views/Cart/index.vue"),
    children: [
      {
        path: "/cart/cart",
        name: "cart-cart",
        component: () => import("../views/Cart/Cart.vue"),
        meta: {
          title: "购物车",
          requiresAuth: true,
        },
      },
      {
        path: "/cart/checkout/:no",
        name: "cart-checkout",
        component: () => import("../views/Cart/checkout/index.vue"),
        meta: {
          title: "结算页",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/ContentDetails",
    name: "ContentDetails",
    component: () => import("../views/ContentDetails/index.vue"),
    meta: {
      title: "",
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 用来判断用户是否已登录
const isAuthenticated = () => {
  if (useLocalStorage.get(USER_TOKEN)) {
    return true;
  }
  return false;
};

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 需要登录的路由
    if (!isAuthenticated()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }, // 登录后跳转回原页面
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
